import { RFValue } from 'react-native-responsive-fontsize';

const PANEL_SCREEN_MARGIN = RFValue(10);
const PANEL_WIDTH_RATIO = 0.62;
const SLIDE_OFFSET = RFValue(28);

/** Decide se o painel abre para a esquerda ou direita conforme posição do chip. */
export function computeFilterPickerPanelLayout(anchor, screenWidth, fallbackTop) {
  const panelWidth = screenWidth * PANEL_WIDTH_RATIO;
  const maxLeft = screenWidth - PANEL_SCREEN_MARGIN - panelWidth;
  const margin = PANEL_SCREEN_MARGIN;

  if (!anchor) {
    return {
      panelTop: fallbackTop,
      panelLeft: maxLeft,
      panelWidth,
      slideFrom: SLIDE_OFFSET,
    };
  }

  const chipRight = anchor.left + anchor.width;
  const chipCenterX = anchor.left + anchor.width / 2;
  const opensToLeft = chipCenterX >= screenWidth * 0.5;

  let panelLeft;
  let slideFrom;

  if (opensToLeft) {
    panelLeft = Math.max(margin, chipRight - panelWidth);
    slideFrom = SLIDE_OFFSET;
  } else {
    panelLeft = Math.max(margin, anchor.left);
    slideFrom = -SLIDE_OFFSET;
  }

  panelLeft = Math.min(panelLeft, maxLeft);

  return {
    panelTop: anchor.top,
    panelLeft,
    panelWidth,
    slideFrom,
  };
}
